import { render, staticRenderFns } from "./expense-settlement.vue?vue&type=template&id=5cbf469d&scoped=true"
import script from "./expense-settlement.vue?vue&type=script&lang=js"
export * from "./expense-settlement.vue?vue&type=script&lang=js"
import style0 from "./expense-settlement.vue?vue&type=style&index=0&id=5cbf469d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbf469d",
  null
  
)

export default component.exports